/**
 * Phase 1 pricing groundwork — SINGLE source for the displayed price.
 * Reads /api/billing/products so a later 14,90/9,90 transition changes
 * data, not scattered copy. Falls back to the current live price.
 */
import { useQuery } from "@tanstack/react-query";
import { getBillingProducts } from "../api/publicApi";

const FALLBACK_DISPLAY = "10 €";

export function usePricing() {
  const { data } = useQuery({
    queryKey: ["billing-products"],
    queryFn: getBillingProducts,
    staleTime: 10 * 60 * 1000,
    retry: 1,
  });
  const web = data?.web;
  return {
    display: web?.display || FALLBACK_DISPLAY,
    priceCents: web?.price_cents ?? 1000,
    currency: web?.currency || "EUR",
  };
}
